import styled from 'styled-components';
import CloseIconSvg from '../assets/flight/icons/close.svg';

const CloseIcon = styled(CloseIconSvg)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || props.theme.colors.goBrand.blue};
`;

export default CloseIcon;
